<template>
  <QuestionWrapper>
      <QuestionTitle>
        What best describes you?
      </QuestionTitle>
      <ChoicesWrapper>
        <Choice
          v-bind:selected="question.selected"
          @click="setLookingFor(question.id)"
          v-for="question in questions"
          >
          <ChoiceTitle>{{question.title}}</ChoiceTitle>
          <ChoiceBlurb>{{question.blurb}}</ChoiceBlurb>
          <ChoiceContext>{{question.context}}</ChoiceContext>
        </Choice>
      </ChoicesWrapper>
  </QuestionWrapper>
</template>

<script>
import OnboardingView from './OnboardingView'
export default {
  computed: {
    preference() {
      return this.$store.state.preference
    }
  },
  data() {
    return {
      questions: [{
          title: "Curious",
          context: "Looks like fun, would like to give it a shot.",
          id: "starting-learn-and-play-songs",
          blurb: 'Dipping your toes',
          selected: false
        },
        {
          title: "Motivated",
          context: 'Ready for work, i want to play!',
          id: 'starting-learn-and-grow',
          blurb: 'Ready to commit...',
          selected: false
        },
        {
          title: "Digging In",
          context: 'Love music, i want this to be a big part of my life',
          id: 'experienced-looking-for-growth',
          blurb: 'Kick my ass please...',
          selected: false
        }
      ]
    }
  },
  methods: {
    setLookingFor(questionID) {

      this.questions.forEach( (question, index) => {
        console.log(question)
        if (question.id === questionID){
            question.selected = true
        } else {
            question.selected = false
        }
      })


      this.$store.commit('setLookingFor', questionID)
    }
  }
}
</script>



<style scoped>

.selection{
  width: 25vw;
  height: 150px;

  /*
  background: white;
  padding: 40px;
  margin: 10px;
  box-shadow: 0 3px 3px rgba(0,0,0,0.2);
  */

  padding: 40px;
  margin: 10px;
  background: #FFFFFF;
  box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.11);

  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/onboarding/Question.vue